import React from 'react';
import styled from 'styled-components';

const Container = styled.nav`
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;

  box-shadow: 0 0 7px 1px rgba(0, 0, 0, 0.25);
`;

const Logo = styled.a`
  display: flex;
  & img {
    height: 50px;
  }
`;

const Navbar = () => {
  return (
    <Container>
      <Logo href="http://www.ippd.or.th" target="_blank">
        <img alt="ippd logo" src="./logo/IPPD__Wordmark_Color.jpg" />
      </Logo>
    </Container>
  );
};

export default Navbar;
